import React, { useCallback } from "react";
import SidebarSection from "domains/inference/components/InferenceGenerator/Sidebar/Section";
import { ConceptItem } from "domains/inference/components/InferenceGenerator/Sidebar/SectionConcepts";
import { useCreateBlendContext } from "domains/models/contexts/CreateBlendProvider";

import { Center, Image, Text, VStack } from "@chakra-ui/react";

export default function BlendConceptSliders() {
  const { concepts, setConcepts, removeConcept } = useCreateBlendContext();

  const handleConceptChange = useCallback(
    (modelId: string, scale: number) => {
      const updatedConcepts = concepts.map((concept) => {
        if (concept.modelId === modelId) {
          return { ...concept, scale };
        }
        return concept;
      });
      setConcepts(updatedConcepts);
    },
    [concepts, setConcepts]
  );

  return (
    <SidebarSection
      headerProps={{
        title: "Model Components",
        id: "models",
        guide: "composition-models",
      }}
    >
      <VStack align="stretch" spacing={4}>
        {concepts.length ? (
          concepts.map((concept) => (
            <ConceptItem
              key={concept.modelId}
              modelId={concept.modelId}
              currentScale={concept.scale}
              onScaleChange={handleConceptChange}
              onRemoveConcept={removeConcept}
            />
          ))
        ) : (
          <Center flexDir="column">
            <Image
              w={160}
              alt="empty blend list icon"
              src="/ui/blend-empty-list.svg"
            />
            <Text
              align="center"
              maxW={250}
              pt={3}
              color="textSecondary"
              size="body.md"
            >
              Add up to 5 models to create a custom composition
            </Text>
          </Center>
        )}
      </VStack>
    </SidebarSection>
  );
}
